import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {selectTenantRoleData} from "../../shared/state/auth/auth.selectors";
import {filter, map, take} from "rxjs/operators";
import {TenantRole} from "../../shared/models/tenant-role.model";

export const addinAccessGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(selectTenantRoleData).pipe(
    filter((tenantRoleData): tenantRoleData is TenantRole => !!tenantRoleData && !!tenantRoleData.tenant),
    take(1),
    map(tenantRoleData =>
      (tenantRoleData.tenant.addinAccess || tenantRoleData.tenant.webappAccess)
        ? true
        : router.parseUrl('auth/not-authorized'))
  );
};
